
function setError( message, input, parentNode = null )
{
  parentNode = parentNode || input.parentNode

  let errorNode = parentNode.querySelector( '.input-feedback-error' )

  if( !errorNode ){
    errorNode = document.createElement( 'p' )
    errorNode.classList.add( 'input-feedback-error' )
    parentNode.appendChild( errorNode )
  }

  input.classList.add( 'input-error' )
  errorNode.textContent = message
}

function clearError( input, parentNode = null )
{
  parentNode = parentNode || input.parentNode

  input.classList.remove( 'input-error' )

  const error = parentNode.querySelector( '.input-feedback-error' )
  if( error ) error.remove()
}

export {
  setError,
  clearError,
}
